import useI18n from "@i18n";
import { Box, Stack, Typography, useTheme } from "@mui/material";

interface BootcampStepProgressProps {
  completedSteps: number;
}

const BOOTCAMP_STEP_COUNT = 7;

const BootcampStepProgress = ({ completedSteps }: BootcampStepProgressProps) => {
  const theme = useTheme();
  const { i18n } = useI18n();
  const completedColor = theme.palette.dsGreen?.v200 ?? theme.palette.dsSuccess.v200;

  return (
    <Stack gap={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="baseline">
        <Typography variant="text2xl700" color="dsBase.v200">
          {i18n("session-results.bootcamp.progress-count", { current: completedSteps })}
        </Typography>
        <Typography variant="text1xl400" color="dsNeutral.v300">
          {i18n("session-results.bootcamp.progress-label")}
        </Typography>
      </Stack>
      <Box display="grid" gridTemplateColumns={`repeat(${BOOTCAMP_STEP_COUNT}, 1fr)`} gap={2.5} role="progressbar" aria-valuenow={completedSteps}>
        {Array.from({ length: BOOTCAMP_STEP_COUNT }, (_, index) => (
          <Box
            key={index}
            height={14}
            borderRadius={999}
            sx={{ backgroundColor: index < completedSteps ? completedColor : "rgba(255, 255, 255, 0.10)" }}
          />
        ))}
      </Box>
    </Stack>
  );
};

export default BootcampStepProgress;
